import { useEffect, useId } from 'react';
import { confirmDialog } from '@/components/ConfirmDialog';

/**
 * T-55: answers typed on a task's question or suggestion cards and not sent yet. Leaving the page is
 * guarded by useUnsavedChangesGuard in each card; closing the task's pop-up or panel (which stays on
 * the page) asks here, so it only asks about the task's own drafts, not the page's.
 */
const drafts = new Set<string>();

/** Registers this card's unsent answers while `dirty`. */
export function useTaskDraft(dirty: boolean) {
  const id = useId();
  useEffect(() => {
    if (!dirty) return;
    drafts.add(id);
    return () => {
      drafts.delete(id);
    };
  }, [dirty, id]);
}

/** Before closing a task: true when there's nothing unsent, or the person agrees to lose it. */
export async function confirmCloseTaskDrafts(): Promise<boolean> {
  if (!drafts.size) return true;
  return confirmDialog({
    title: 'Close this task?',
    description: 'Your answers on it aren’t sent yet. Close without sending them?',
    confirmLabel: 'Close',
  });
}
